export default function ComparisonSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            OOPBuy Spreadsheet vs Other Shopping Systems
          </h2>
          <p className="text-base text-foreground-500 max-w-[600px] mx-auto">
            See how the <strong>spreadsheet shopping system</strong> compares to alternatives
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse bg-background-50 rounded-2xl overflow-hidden">
            <thead>
              <tr className="bg-secondary-200/60">
                <th className="text-left px-6 py-4 font-semibold text-sm text-foreground-800 whitespace-nowrap">
                  Feature
                </th>
                <th className="text-left px-6 py-4 font-semibold text-sm text-primary-700 whitespace-nowrap">
                  OOPBuy Spreadsheet
                </th>
                <th className="text-left px-6 py-4 font-semibold text-sm text-foreground-600 whitespace-nowrap">
                  Traditional Shopping
                </th>
                <th className="text-left px-6 py-4 font-semibold text-sm text-foreground-600 whitespace-nowrap">
                  Other Agents
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i} className="border-t border-background-200/50">
                  <td className="px-6 py-4 text-sm text-foreground-600 font-medium">
                    {row.feature}
                  </td>
                  <td className="px-6 py-4">
                    <span className="inline-flex items-center gap-1.5 text-sm text-primary-700 font-medium">
                      <i className="ri-checkbox-circle-fill text-accent-500 text-base"></i>
                      {row.oopbuy}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-foreground-500">
                    {row.traditional}
                  </td>
                  <td className="px-6 py-4 text-sm text-foreground-500">
                    {row.otherAgents}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}

const rows = [
  {
    feature: 'Product Organization',
    oopbuy: 'Advanced spreadsheet system',
    traditional: 'None',
    otherAgents: 'Basic',
  },
  {
    feature: 'Price Comparison',
    oopbuy: 'Real-time structured',
    traditional: 'Manual',
    otherAgents: 'Partial',
  },
  {
    feature: 'Ease of Use',
    oopbuy: 'Beginner-friendly',
    traditional: 'Medium',
    otherAgents: 'Medium',
  },
  {
    feature: 'Transparency',
    oopbuy: 'High',
    traditional: 'Low',
    otherAgents: 'Medium',
  },
  {
    feature: 'Efficiency',
    oopbuy: 'High',
    traditional: 'Low',
    otherAgents: 'Medium',
  },
  {
    feature: 'Order Tracking',
    oopbuy: 'Integrated system',
    traditional: 'Limited',
    otherAgents: 'Partial',
  },
];